import React, { useReducer } from "react";
import axios from "axios";
import CountryContext from "./CountryContext";
import CountryReducer from "./CountryReducer";
import {
  GET_MERN_COUNTRIES,
  GET_MERN_COUNTRY,
  MERN_COUNTRY_ERROR,
} from "../types";

const CountryState = (props) => {
  const initialState = {
    mern_countries: null,
    mern_country: null,
    mern_country_error: null,
  };

  const [state, dispatch] = useReducer(CountryReducer, initialState);

  const getMernCountries = async () => {
    try {
      const res = await axios.get("/api/mern_countries/");

      dispatch({
        type: GET_MERN_COUNTRIES,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: MERN_COUNTRY_ERROR,
        payload: err.response.msg,
      });
    }
  };

  const getMernCountry = async (id) => {
    try {
      const res = await axios.get(`/api/mern_countries/${id}`);

      dispatch({
        type: GET_MERN_COUNTRY,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: MERN_COUNTRY_ERROR,
        payload: err.response.msg,
      });
    }
  };

  return (
    <CountryContext.Provider
      value={{
        mern_countries: state.mern_countries,
        mern_country: state.mern_country,
        mern_country_error: state.mern_country_error,
        getMernCountries,
        getMernCountry,
      }}
    >
      {props.children}{" "}
    </CountryContext.Provider>
  );
};

export default CountryState;
